"use strict";

export default class VideoContentCtrl {
  static get UID() {
    return "videoContentCtrl";
  }

  constructor($stateParams, $sce, sceneFac, BASE_URLS) {
    "ngInject";

    Object.assign(this, { $stateParams, $sce, sceneFac, BASE_URLS });

    var currentlyPlayingFile;

    this.video = {};
    this.playerConfig = {
      preload: "none",
      plugins: {
        controls: {
          autoHide: true,
          autoHideTime: 5000
        }
      }
    };

    sceneFac.getScene(this.$stateParams.updateId).then(response => {
      this.video = response;

      this.videoFiles = { t: "", f: "", parts: [] };
      this.imageFiles = this.video.files.images;
      this.video.files.videos.map(x => {
        if (x.usedFor === "t") {
          this.videoFiles.t = x;
        } else if (x.part === "f") {
          this.videoFiles.f = x;
        } else {
          this.videoFiles.parts.push(x);
        }
      });

      var file = this.videoFiles.t;
      this.playerConfig.sources = [
        {
          src: $sce.trustAsResourceUrl(
            this.BASE_URLS.CONTENT + file.download_link
          ),
          type: "video/" + file.format
        }
      ];

      this.currentlyPlayingFile = file.name.toLowerCase();

      if (file.width && file.height) {
        this.dims = {
          width: file.width + "px",
          height: file.height + "px",
          stageHeight: file.height + 10 + "px"
        };
      }

      // setup the image content
      this.shownImages = [];
      for (var x = 0; x < 6; x++) {
        this.shownImages.push(this.imageFiles[x]);
      }

      return sceneFac
        .getRelatedScenes(this.$stateParams.updateId, 3)
        .then(related => {
          this.relatedVideos = related;
          return this.relatedVideos;
        });
    });
  }

  activeVideoFile(file) {
    if (!file || !file.videoFile) return false;
    if (
      !this.currentlyPlayingFile &&
      file.videoFile.part.toLowerCase() === "t"
    ) {
      return true;
    } else if (
      file.videoFile.name.toLowerCase() === this.currentlyPlayingFile
    ) {
      return true;
    }

    return false;
  }

  playFile(file) {
    const { videoFile } = file;

    this.currentlyPlayingFile = videoFile.name.toLowerCase();
    this.playerConfig.sources = [
      {
        src: this.$sce.trustAsResourceUrl(
          this.BASE_URLS.CONTENT + videoFile.download_link
        ),
        type: "video/" + videoFile.format
      }
    ];

    if (videoFile.width && videoFile.height) {
      this.dims = {
        width: videoFile.width + "px",
        height: videoFile.height + "px",
        stageHeight: videoFile.height + 10 + "px"
      };
    }
  }

  // load more images onto array for infinite scroll
  getMoreImages() {
    if (!this.video || !this.shownImages) {
      return;
    }

    var start = this.shownImages.length || 0;
    var end = this.imageFiles.length - 1;

    for (var x = start; x <= start + 5 && x <= end; x++) {
      this.shownImages.push(this.imageFiles[x]);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/features/videoContentCtrl.js